import { render, staticRenderFns } from "./FileUser.vue?vue&type=template&id=68ea1d04&"
import script from "./FileUser.vue?vue&type=script&setup=true&lang=js&"
export * from "./FileUser.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports